import "./pentab.css";

const Pentab = (props) => {
  return (
    <div className={
      `Pentab
    ${props.dadaFadeOut && "dadaFadeOut"}`
    }>

    </div>
  )
}

export default Pentab;
